<template>
  <div id="auth-layout">
    <div class="sidebar-wrapper">
      <i
        v-if="state.isMobile"
        class="bi sidebar-toggle"
        :class="state.isOpen ? 'bi-x-lg' : 'bi-list'"
        @click="appStore.toggleSidebar(!appStore.sidebarIsOpen)"
      />
      <Sidebar :isMobile="state.isMobile" />
    </div>
    <main>
      <Suspense>
        <router-view v-slot="{ Component, route }">
          <transition mode="out-in" name="fade">
            <div :key="route.path">
              <component :is="Component" :id="route.name" />
            </div>
          </transition>
        </router-view>
      </Suspense>
    </main>
    <PaymentModal
      :isOpen="appStore.paymentModalIsOpen"
      :creditsNeeded="appStore.creditsNeeded"
      @close="
        (appStore.paymentModalIsOpen = false), (appStore.creditsNeeded = 1)
      "
    />
    <NewsModal
      v-if="!!appStore.currentNews && !appStore.onboardingIsLive"
      :is-open="!!appStore.currentNews && !appStore.onboardingIsLive"
      :title="appStore.currentNews.title"
      :text="appStore.currentNews.text"
      @close="appStore.dismissNews"
    />
  </div>
</template>

<script setup>
import { useRoute } from "vue-router";
import { reactive, onMounted, watch, inject } from "vue";
import { useUserStore } from "@/stores/user.js";
import { useAppStore } from "@/stores/app.js";
import { useCompanyStore } from "@/stores/company.js";
import { getImage } from "@/composables/getImage.js";
import Sidebar from "@/components/sidebar/Sidebar.vue";
import PaymentModal from "@/components/payment/PaymentModal.vue";
import NewsModal from "@/components/modals/app/NewsModal.vue";

const route = useRoute();

const crisp = inject("crisp");

const { user } = useUserStore();

const appStore = useAppStore();

const companyStore = useCompanyStore();

const state = reactive({
  isMobile: false,
});

watch(route, () => {
  state.isMobile ? appStore.toggleSidebar(false) : null;
});

onMounted(async () => {
  state.isMobile = window.innerWidth <= 1100;

  window.addEventListener("resize", () => {
    state.isMobile = window.innerWidth <= 1100;
  });

  crisp.session.setSegments(["Recruteur"]);

  if (user.user_id) {
    crisp.user.setEmail(user.email);
    crisp.user.setNickname(`${user.first_name} ${user.last_name}`);
    crisp.user.setCompany(companyStore.currentCompany.name);

    if (user.image_id) {
      crisp.user.setAvatar(getImage(user.image_id));
    }

    crisp.session.setData({
      user_id: user.user_id,
    });
  }
});

watch(
  () => appStore.onboardingIsLive,
  (isLive) => {
    if (isLive) {
      window.onpopstate = async function () {
        appStore.exitOnboarding();
      };
    } else {
      window.onpopstate = null;
    }
  },
  { immediate: true }
);
</script>
